import { useRef, useState } from "react";
import $ from "jquery";
import axios from "axios"; 
import FormValidator from "../../../inc/FormValidator";
import Api from "../../../inc/Api";
import Settings from "../../../inc/Settings";
import Button from "../../inc/Button";
import Collapse from "../../inc/Collapse"; 
import FieldsRenderer from "../../Purchase Orders Internal/Edit PO/FieldsRenderer";
import Helper from "../../../inc/Helper";
import { Form } from "react-bootstrap";
import { getPopupMessageBasedOnStatus } from "../../../inc/Validation";
import Popup from "../../Popup/Popup"; 
import { connect } from "react-redux";

let cancelTokenSource = axios.CancelToken.source();
const ApiManagerPopup = ({ setClosePopupViewModal, reloadParentGrid }) => {
  const [popupFormData, setPopupFormData] = useState({});
 
  const [apiCallBtn, setApiCallBtn] = useState(false);
  const appDataRef = useRef([]);

  let popupFormValidator;

  const validationConfigure = () => {
    let popupFieldConfig = [
      { name: "api_url", displayName: "Api url", types: ["Required"] },
      { name: "api_method", displayName: "Api method", types: ["Required"] }, 
      { name: "app", displayName: "App", types: ["Required"] }
    ];

    if (!popupFormValidator) {
      popupFormValidator = new FormValidator(popupFieldConfig);
    }
  };

  validationConfigure();

  const appMapFunction = (item) => {
    return {
      text: `${item.app_name}`,
      id: item.app_id
    };
  };

  const fieldsArrayGeneral = [
    {
      className: "col-lg-4",
      label: "Api url",
      inputType: "text",
      id: "api_url",
      required: true,
      name: "api_url",
    },
    {
      className: "col-lg-4",
      label: "Api method",
      inputType: "dropdown",
      options: Settings.httpMethodOptions,
      id: "api_method",
      name: "api_method",
      required: true,
    },
    {
      className: "col-lg-4",
      label: "App",
      inputType: "paginated_dropdown",
      options: [],
      apiUrl: Settings.apiAppUrl+'/details',
      currentSearchTerm: '',
      allDataRef: appDataRef,
      mapFunction: appMapFunction,
      placeHolder: 'Select app',
      id: "app",
      name: "app",
      required: true
    },
    {
      className: "col-lg-4",
      label: "Status",
      inputType: "dropdown",
      options: Settings.enumStatus,
      id: "status",
      placeHolder: 'Select status',
      name: "status"
    },
    {
      className: "col-lg-4",
      label: "Api name",
      inputType: "dropdown",
      options: Settings.apiNamesEnum,
      id: "api_name",
      name: "api_name",
      placeHolder: 'Select api name'
    },
    {
      className: "col-lg-4",
      label: "Timeout",
      inputType: "number",
      id: "timeout",
      name: "timeout"
    },
    {
      className: "col-lg-4",
      label: "Retry count",
      inputType: "number",
      id: "retry_count",
      name: "retry_count"
    },  
    {
      className: "col-lg-4",
      label: "Body",
      inputType: "textarea",
      id: "body",
      name: "body"
    },
    {
      className: "col-lg-4",
      label: "Sample payload",
      inputType: "textarea",
      id: "sample_payload",
      name: "sample_payload"
    },
    {
      className: "col-lg-4",
      label: "Priority",
      inputType: "number",
      id: "priority",
      name: "priority"
    },
    {
      className: "col-lg-4",
      label: "is Asynchronous", 
      inputType: "checkbox",
      id: "is_asynchronous",
      name: "is_asynchronous"
    }
  ];

  const onClosePopupClick = () => {
    $("html").removeClass("rs_popup_open");
    setClosePopupViewModal(false);
  };

  const executePOSTPopupDocumentAPI = async () => {
    try { 
      let api = Api;
      api.setUserToken();

      const res = await api
        .axios()
        .post(
          Settings.apiAppUrl + "/api-manager/",
          { ...popupFormData,
            retry_count: popupFormData.retry_count ? parseInt(popupFormData.retry_count) : null,
            priority: popupFormData.priority ? parseInt(popupFormData.priority) : null,
            timeout: popupFormData.timeout ? parseInt(popupFormData.timeout) : null,
            is_asynchronous: popupFormData?.is_asynchronous == 'on' 
          },
          { cancelToken: cancelTokenSource.token }
        );
        
      if (res?.data?.success || res?.status === 201) {
        Helper.alert(res?.data?.message || 'Api manager created successfully', 'success'); 
        reloadParentGrid();
        onClosePopupClick(); 
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    } catch (error) { 
      getPopupMessageBasedOnStatus(error);
    }
  };

  const handleSubmit = () => {
    if (!popupFormValidator.isValid({ ...popupFormData })) {
      popupFormValidator.displayMessage();
      popupFormValidator.reset();
      return;
    };

    Helper.createDebouncedAPIFunction(
      [executePOSTPopupDocumentAPI],
      setApiCallBtn,
      cancelTokenSource
    )();
  };
  return (
    <Popup
      autoOpen={true}
      width="1000px"
      onClose={onClosePopupClick}
    >
      {(
        <>
          <h5 className="create_rfq_modal__title">Create Api Manager</h5>

          <Collapse
            className="mt-4 mb-4"
            open={true}
            title={"General Information"}
          >
            <Form>
              <div className="container-fluid">
                <FieldsRenderer
                  updateState={setPopupFormData}
                  currentState={popupFormData}
                  fieldsArray={fieldsArrayGeneral}
                />
              </div>
            </Form>
          </Collapse>
        </>
      )}

      <div
        className="addDocumentNumber-body-buttons"
        style={{ justifyContent: "flex-end" }}
      >
        <Button
          isActive={false}
          title={"Cancel"}
          onClick={onClosePopupClick}
        />
        <Button
          isDisable={apiCallBtn}
          className="solid_btn"
          isActive={true}
          title={<div><span> {"Create"} </span> {apiCallBtn ? <output className="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output> : ''}</div>} 
          onClick={handleSubmit}
        />
      </div>
    </Popup>
  );
};

const mapStateToProps = (state) => {
  return {
    auth:state.auth
  }
};

export default connect(mapStateToProps) (ApiManagerPopup);